export default {"src":"/_next/static/image/public/images/verify_failure.6407ec800c5b34d4f1fe32b1f600e5fa.svg","height":148,"width":142};